import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map, catchError, tap } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class CrmsettingsService {


  constructor(private http: HttpClient) { }
  url = environment.serverAPI9 + "/api";

  url1 = environment.serverAPI + "/api";


  // getCrmSettingsData(): Observable<Object> {
  //   return this.http.get(`${this.url}/crmConfig`);
  // }

  getListofPages(): Observable<Object> {
    return this.http.get(`${this.url}/facebook/pages`);
  }

  saveCrmSetting(crmConfig: any): Observable<Response[]> {

    this.responseCacheConfig.delete(`${this.url}/crmConfig`)


    return this.http.post<Response[]>(`${this.url}/crmConfig`, crmConfig);
  }


  public responseCacheConfig = new Map();

  public getCrmSettingsData(): Observable<any> {

    return this.http.get(`${this.url}/crmConfig`);


  }


  delete() {
    this.responseCacheConfig.delete(`${this.url}/crmConfig`)
  }

  getStorageStatus(): Observable<any> {
    return this.http.get(`${this.url1}/core/storage/status`);
  }

}
